import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactSelect from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import CustomInput from "../../Common/CustomInput/CustomInput";
import {
    addUserWallet,
  addWallet,
  getAllWallet,
  getAllWalletValidity,
  getUserWalletLogs,
} from "../../../redux/wallet/action";
import { Table } from "reactstrap";

const UserWallet = (defaultUserId) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = defaultUserId.defaultUserId || {};
  console.log(id, "defaultUserId");

  const params = {
    page: "1",
    search_key: "",
    status: "",
    user_id: id,
    per_page: "10",
  };

  const validityParams = {
    type: 1,
    search_key: "",
    status: "",
  };

  const walletValidityList = useSelector(
    (state) => state.reusableSlice.WalletValidityList
  );
  const userlist = useSelector(
    ({ user: { userlist } }) => userlist?.users || []
  );
  const walletLogs = useSelector(
    (state) => state.reusableSlice.WalletList?.wallet_entries || []
  );

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState([]);
  const [validity, setValidity] = useState(null);

  // Fetch dropdown data
  useEffect(() => {
    dispatch(getAllWalletValidity(validityParams));
  }, [dispatch]);

  useEffect(() => {
    if (id) dispatch(getAllWallet(params));
  }, [dispatch, id]);

  const proUserOptions = userlist.map((item) => ({
    value: item.id,
    label: item.mobile_number || item.email_id || "-",
  }));

  const additionalTypeOptions = [
    { label: "Advertising", value: 1 },
    { label: "Compensation", value: 2 },
  ];

  const typeOptions = [
    { label: "Credit", value: 1 },
    { label: "Debit", value: 2 },
  ];

  const durationTypeMap = {
    1: "Unlimited",
    2: "Days",
    3: "Weeks",
    4: "Months",
    5: "Years",
  };

  const proValidityOptions = walletValidityList.map((item) => ({
    value: item.id,
    label:
      item.duration_type === 1
        ? durationTypeMap[item.duration_type]
        : `${item.duration} ${durationTypeMap[item.duration_type]}`,
  }));

  const passId = defaultUserId.defaultUserId
    ? String(defaultUserId.defaultUserId)
    : "";

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      reference: "",
      amount: "",
      complain: "",
      usage_percentage: 100,
      user_id: passId,
      additional_type: 1,
      type: 1,
      validity: null,
    },
    validationSchema: Yup.object({
      reference: Yup.string().required("Reference code is required"),
      amount: Yup.number()
        .typeError("Amount must be a number")
        .min(0, "Amount must be positive")
        .required("Amount is required"),
      complain: Yup.string().required("Complain is required"),
      //   user_id: Yup.string()
      //     .required("User is required")
      //     .test("is-valid-user-ids", "Invalid user IDs", (value) => {
      //       if (!value) return false;
      //       return value.split(",").every((id) => /^\d+$/.test(id.trim()));
      //     }),
      additional_type: Yup.number()
        .oneOf([1, 2], "Invalid additional type")
        .required("Additional Type is required"),
      type: Yup.number()
        .oneOf([1, 2], "Invalid type")
        .required("Type is required"),
      validity: Yup.number()
        .typeError("Validity must be a number")
        .min(1, "Validity must be at least 1")
        .required("Validity is required"),
      usage_percentage: Yup.number()
        .typeError("Usage percentage must be a number")
        .min(0, "Minimum is 0")
        .max(100, "Maximum is 100")
        .required("Usage percentage is required"),
    }),
    onSubmit: (values) => handleSubmit(values),
  });

  const handleSubmit = async (values) => {
  setLoading(true);
  try {
    const response = await dispatch(addUserWallet(values, setLoading));
    if (response?.data?.status) {
      // Re-fetch the wallet list after success
      if (id) {
        dispatch(getAllWallet(params));
      }
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const handleChangeUser = (selected) => {
    setUser(selected || []);
    const userIds = (selected || []).map((item) => item.value);
    formik.setFieldValue("user_id", userIds.join(","));
    formik.setFieldTouched("user_id", true);
  };

  return (
    <div className="">
      <div className="sub-head"><h4 className="">Add Wallet</h4></div>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          {/* Select Users */}
          {/* <div className="col-md-6 mb-3">
            <label>Select Users</label>
            <ReactSelect
              value={user}
              onChange={handleChangeUser}
              options={proUserOptions}
              isMulti
              placeholder="Select User(s)"
              onBlur={() => formik.setFieldTouched("user_id", true)}
            />
            {formik.touched.user_id && formik.errors.user_id && (
              <div className="error">{formik.errors.user_id}</div>
            )}
          </div> */}

          {/* Additional Type */}
          <div className="col-md-6 mb-3">
            <label>Additional Type</label>
            <ReactSelect
              options={additionalTypeOptions}
              value={additionalTypeOptions.find(
                (option) => option.value === formik.values.additional_type
              )}
              onChange={(selected) =>
                formik.setFieldValue("additional_type", selected.value)
              }
              onBlur={() => formik.setFieldTouched("additional_type", true)}
              placeholder="Select Additional Type"
            />
            {formik.touched.additional_type &&
              formik.errors.additional_type && (
                <div className="error">{formik.errors.additional_type}</div>
              )}
          </div>

          {/* Type */}
          <div className="col-md-6 mb-3">
            <label>Type</label>
            <ReactSelect
              options={typeOptions}
              value={typeOptions.find(
                (option) => option.value === formik.values.type
              )}
              onChange={(selected) =>
                formik.setFieldValue("type", selected.value)
              }
              onBlur={() => formik.setFieldTouched("type", true)}
              placeholder="Select Type"
            />
            {formik.touched.type && formik.errors.type && (
              <div className="error">{formik.errors.type}</div>
            )}
          </div>

          {/* Reference */}
          <div className="col-md-6 mb-3">
            <label>Reference Code</label>
            <CustomInput
              placeholder="Enter Reference Code"
              name="reference"
              value={formik.values.reference}
              onChange={(e) =>
                formik.setFieldValue(
                  "reference",
                  e.target.value.replace(/[^a-zA-Z0-9]/g, "")
                )
              }
              onBlur={formik.handleBlur}
              error={formik.errors.reference}
              touched={formik.touched.reference}
            />
          </div>

          {/* Amount */}
          <div className="col-md-6 mb-3">
            <label>Amount</label>
            <CustomInput
              type="number"
              placeholder="Enter Amount"
              name="amount"
              value={formik.values.amount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.amount}
              touched={formik.touched.amount}
            />
          </div>

          {/* Usage Percentage */}
          <div className="col-md-6 mb-3">
            <label>Usage Percentage</label>
            <CustomInput
              type="number"
              name="usage_percentage"
              value={formik.values.usage_percentage}
              onChange={(e) => {
                const value = Math.min(100, Number(e.target.value));
                formik.setFieldValue("usage_percentage", value);
              }}
              onBlur={formik.handleBlur}
              error={formik.errors.usage_percentage}
              touched={formik.touched.usage_percentage}
            />
          </div>

          {/* Validity */}
          <div className="col-md-6 mb-3">
            <label>Validity</label>
            <ReactSelect
              options={proValidityOptions}
              value={proValidityOptions.find(
                (option) => option.value === formik.values.validity
              )}
              onChange={(selected) =>
                formik.setFieldValue("validity", selected?.value || null)
              }
              onBlur={() => formik.setFieldTouched("validity", true)}
              placeholder="Select Validity"
            />
            {formik.touched.validity && formik.errors.validity && (
              <div className="error">{formik.errors.validity}</div>
            )}
          </div>

          {/* Complain */}
          <div className="col-md-6 mb-3">
            <label>Complain</label>
            <CustomInput
              as="textarea"
              placeholder="Enter Complain"
              name="complain"
              value={formik.values.complain}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.complain}
              touched={formik.touched.complain}
            />
          </div>
        </div>

        <div className="d-flex justify-content-between my-3">
          {/* <button
            type="button"
            className="back-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button> */}
          <button type="submit" className="submit-btn">
            {!loading ? "Submit" : <Spinner />}
          </button>
        </div>
      </form>

      {/* Wallet Logs Table */}
      <div className="wallet-log mt-4">
        <h3>Wallet Logs</h3>
        <Table striped responsive>
          <thead>
            <tr>
              <th>Reference</th>
              <th>Amount</th>
              <th>Type</th>
              <th>Additional Type</th>
              <th>Validity</th>
              <th>Usage %</th>
              <th>Complain</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {walletLogs.length ? (
              walletLogs.map((log) => (
                <tr key={log.id}>
                  <td>{log.reference}</td>
                  <td>{log.amount}</td>
                  <td>{log.type === 1 ? "Credit" : "Debit"}</td>
                  <td>
                    {log.additional_type === 1 ? "Advertising" : "Compensation"}
                  </td>
                  <td>{log.validity}</td>
                  <td>{log.usage_percentage}%</td>
                  <td>{log.complain}</td>

                  <td>
                    {log.created_on.split(" ")[0]} <br />
                    {log.created_on.split(" ")[1]}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="text-center">
                  No logs available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default UserWallet;
